export const hasUserMultipleCompanies = (companyIds: string[]) => {
  return companyIds && companyIds.length > 1;
};
